var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.a5cf5b348c186c96ce6ad5943fba1b44.svg#p';
                    var viewUrl = 'sprites.a5cf5b348c186c96ce6ad5943fba1b44.svg#view-p';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 54 28',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };